import { startIframeResizeObserver } from "./utils/iframe-resizer.js";
import Swiper from "swiper";
import { Navigation, Pagination, Grid } from "swiper/modules";
import { newsletters } from "./utils/newsletters.js";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import "./styles/style.scss";

// --- Swiper-Config  ---
const swiperConfig = {
  modules: [Navigation, Pagination, Grid],
  direction: "horizontal",
  loop: false,
  slidesPerView: 3,
  spaceBetween: 14,
  updateOnWindowResize: true,
  breakpoints: {
    0: { slidesPerView: 3, grid: { rows: 2 } },
    375: { slidesPerView: 3, slidesPerGroup: 3, grid: { rows: 2 } },
    768: { slidesPerView: 6, slidesPerGroup: 6, grid: { rows: 1 } },
    919: { slidesPerView: 8, slidesPerGroup: 8, grid: { rows: 1 } },
  },
  pagination: { el: ".swiper-pagination", clickable: true },
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  on: { init: handleNavigationButtons, slideChange: handleNavigationButtons },
};

function handleNavigationButtons() {
  const prevButton = document.querySelector(".swiper-button-prev");
  const nextButton = document.querySelector(".swiper-button-next");
  if (!prevButton || !nextButton) return;

  if (this.isBeginning) {
    prevButton.classList.add("disabled");
    nextButton.classList.remove("disabled");
  } else if (this.isEnd) {
    prevButton.classList.remove("disabled");
    nextButton.classList.add("disabled");
  } else {
    prevButton.classList.remove("disabled");
    nextButton.classList.remove("disabled");
  }
}

// --- Slides dynamisch rendern ---
function getPlainLabel(label) {
  return label
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function renderSlides(wrapperEl) {
  const fragment = document.createDocumentFragment();

  for (const newsletter of newsletters) {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";
    slide.innerHTML = `
      <a href="${newsletter.url}" target="_parent">
        <section class="inner">
          <img class="newsletter-icon" src="${newsletter.icon}" alt="${getPlainLabel(newsletter.label)}" loading="lazy" decoding="async" />
          <div class="label">${newsletter.label}</div>
        </section>
      </a>
    `;
    fragment.appendChild(slide);
  }

  wrapperEl.appendChild(fragment);
}

// --- Init ---
function initSwiper() {
  const swiperElement = document.querySelector(".swipernewsletter");
  if (!swiperElement) {
    console.error("Swiper element not found");
    return null;
  }

  const wrapper = swiperElement.querySelector(".swiper-wrapper");
  renderSlides(wrapper);

  return new Swiper(swiperElement, swiperConfig);
}

document.addEventListener("DOMContentLoaded", () => {
  const swiper = initSwiper();
  if (swiper) {
    console.log("Newsletter Slider initialized successfully");
    startIframeResizeObserver();
  }
});

export { initSwiper, swiperConfig };
